export default {
    day: '2024-06-09',
    content: {
        card: [
            {
                type: 'balance',
                text: '299_2'
            }
        ],
        farm: [
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '299_4'
            },
        ],
        event: [
            {
                unlock: 'weatherChaosEvent',
                type: 'bugfix',
                text: '299_1'
            },
            {
                unlock: 'weatherChaosEvent',
                type: 'balance',
                text: '299_3'
            }
        ]
    }
}
